(function () {
    'use strict';

    angular
        .module('webinar')
        .controller('WebinarRequestAttendeesController', WebinarRequestAttendeesController);

        WebinarRequestAttendeesController.$inject = ['$uibModalInstance', 'webinarItem','WebinarService', 'FileUploader', 'API_BASE', 'toastr'];

    function WebinarRequestAttendeesController($uibModalInstance, webinarItem, WebinarService, FileUploader, API_BASE, toastr) {
        var vm = this;

        vm.webinarItem     = webinarItem;
        vm.ok              = ok;
        vm.cancel          = cancel;
        vm.attendeesFile   = '';
        vm.uploading       = false;
        vm.tokenHeader     = 'Bearer ' + localStorage.getItem('id_token');

        activate();

        function activate() {
        }

        function ok () {
            $uibModalInstance.close();
        }

        function cancel () {
            $uibModalInstance.close();
        }

        vm.uploader = new FileUploader({
            url: API_BASE + '/webinar/attendeesfile',
            formData: [{id : webinarItem.webinar.id}],
            withCredentials: false,
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + vm.tokenHeader
            },
            queueLimit: 1,
            onCompleteAll: function () {
                vm.uploading = false;
                vm.uploader.clearQueue();
            },
            onProgressAll : function(progress) {
                vm.uploading = true;
            }
        });
        vm.uploader.onCompleteItem = function(fileItem, response, status, headers) {
        };
        vm.uploader.onSuccessItem = function(fileItem, response, status, headers) {
            toastr.success('Attendees file sucessfull uploaded');
            webinarItem.webinar.attendees_file = response;
            vm.cancel();
        };
        vm.uploader.onErrorItem = function(fileItem, response, status, headers) {
            toastr.error('Attendees file not uploaded');
        };
        vm.uploader.onCancelItem = function(fileItem, response, status, headers) {
        };
    }

})();